let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("51g3z")).then(() => parcelRequire('kIqMQ'));